import { UICheckboxField } from 'browser/components/ui-fields/ui-checkbox'
import { UIView } from 'browser/components/json-elements/atoms/view'
import { UIConditional } from 'browser/components/json-elements/atoms/conditional'
import { Spacer } from 'browser/components/atomic-elements/atoms/spacer/spacer'
import { SignatureField } from 'browser/components/atomic-elements/molecules/fields/signature-field/signature-field'
import { QRCodeField } from 'browser/components/atomic-elements/molecules/fields/qrcode-field'
import { HelpBlock } from 'browser/components/atomic-elements/atoms/help-block/help-block'
import { If } from 'browser/components/atomic-elements/atoms/if'
import { Separator } from 'browser/components/atomic-elements/atoms/separator'
import { ImageLoader } from 'browser/components/atomic-elements/atoms/image-loader/image-loader'
import { Text } from './text/text'
import { MobileEntityDetails } from './entity-details/entity-details'
import { MobileForm } from './form/form'
import { WorkflowManager } from 'browser/components/containers/workflow-manager'
import { MobileFileField } from './file-field/mobile-file-field'
import { MobileGeolocationField } from './geolocation-field/mobile-geolocation-field'
import { MobileInputField } from './input/mobile-input-field'
import { MobileLabel } from './label/mobile-label'
import { WorkflowButton } from './workflow-button/workflow-button'
import { MobileSelectField } from './select/mobile-select-field'
import { MobileESignatureField } from './signature/mobile-signature-field'
import { Section } from 'browser/components/atomic-elements/atoms/section/section'
import { MobileBarcodeField } from './barcode/barcode-field'
import { Barcode } from 'browser/components/atomic-elements/atoms/barcode/barcode'
import { OcrCameraField } from './ocr-field/ocr-camera-field'
import { FormulaField } from 'browser/components/atomic-elements/molecules/fields/formula-field'
import { JSONElementFactory } from 'browser/components/json-elements/higher-order-components/json-element-factory'
import { JSONInputFactory } from 'browser/components/json-elements/higher-order-components/json-input-factory'
import { BlindMatchInputField } from 'browser/components/atomic-elements/molecules/fields/blind-match-field/blind-match-field'
import { MobileSwitch } from './switch/mobile-switch'
import { MobileList } from './list/mobile-list'
import { ProgressBar } from './progress-bar/progress-bar'
import { UploadProgress } from './upload-progress'
import { PermissionStatusProvider } from 'browser/contexts/permission-status/permission-provider'
import { AttachmentViewer } from 'browser/components/atomic-elements/atoms/attachment-viewer/attachment-viewer'
import { PrintableRender } from 'browser/components/atomic-elements/atoms/printable-render/printable-render'
import {
  MobileRadioButtonGroup,
  MobileRadioButtonGroupField,
} from './radio-button/mobile-radio-button-field'
import { MobileRecipientsField } from './recipients/mobile-recipients-field'
import { LoadingSpinner } from 'browser/components/atomic-elements/atoms/loading-spinner/loading-spinner'
import { MobileDateField } from './date-field/mobile-date-field'
import { MobileEntitySelectField } from './entity-search/mobile-entity-select-field'
import { MobileEntitySearchField } from './entity-search/mobile-entity-search-field'
import { CheckinSummaryCard } from '../pages/kiosk/checkin/checkin-summary-card'
import { Icon } from 'browser/components/atomic-elements/atoms/icon/icon'
import { AppointmentSearch } from '../pages/kiosk/checkin/appointment-search'
import { KioskCompanyLogo, KioskInputField } from '../pages/kiosk/utils'
import { AppointmentCard } from '../pages/kiosk/checkin/appointment-card'
import { UIHtmlTable, UIHtmlTableRow } from 'browser/components/json-elements/atoms/html-table'
import { MobileEntityPreviewCard } from './entity-preview-card/mobile-entity-preview-card'
import { CacResumeCheckInButton } from './cac-resume-checkin-button/cac-resume-checkin-button'
import { BackButton } from './back-button/back-button'
import { PreCheckDetailCard } from './pre-check-detail-card/pre-check-detail-card'
import { EntityAddButton } from 'browser/components/atomic-elements/organisms/entity/entity-add-button/entity-add-button'

const UIFormulaField = JSONInputFactory(FormulaField)
const UIBlindMatchInputField = JSONElementFactory(BlindMatchInputField)


export default {
  'ui:dateField': MobileDateField,
  'ui:attachmentViewer': AttachmentViewer,
  'ui:printableRender': PrintableRender,
  'ui:spacer': Spacer,
  'ui:checkboxField': UICheckboxField,
  'ui:view': UIView,
  'ui:conditional': UIConditional,
  'ui:signatureField': SignatureField,
  'ui:eSignatureField': MobileESignatureField,
  'ui:switch': MobileSwitch,
  'ui:qrCodeField': QRCodeField,
  'ui:barcode': Barcode,
  'ui:barcodeField': MobileBarcodeField,
  'ui:image': ImageLoader,
  'ui:selectField': MobileSelectField,
  'ui:inputField': MobileInputField,
  'ui:fileField': MobileFileField,
  'ui:list': MobileList,
  'ui:section': Section,
  'ui:geolocationField': MobileGeolocationField,
  'ui:form': MobileForm,
  'ui:htmlTable': UIHtmlTable,
  'ui:htmlTableRow': UIHtmlTableRow,
  'ui:entityDetails': MobileEntityDetails,
  'ui:ocrCameraField': OcrCameraField,
  'ui:radioButtonGroup': MobileRadioButtonGroup,
  'ui:radioButtonGroupField': MobileRadioButtonGroupField,
  'ui:text': Text,
  'ui:workflowManager': WorkflowManager,
  'ui:label': MobileLabel,
  'ui:helpBlock': HelpBlock,
  'ui:if': If,
  'ui:separator': Separator,
  'ui:workflowButton': WorkflowButton,
  'ui:formulaField': UIFormulaField,
  'ui:blindMatchInputField': UIBlindMatchInputField,
  'ui:progressBar': ProgressBar,
  'ui:uploadProgress': UploadProgress,
  'ui:permissionStatusProvider': PermissionStatusProvider,
  'ui:recipientsField': MobileRecipientsField,
  'ui:loadingSpinner': LoadingSpinner,
  'ui:entitySearchField': MobileEntitySearchField,
  'ui:entityPreviewCard': MobileEntityPreviewCard,
  'ui:icon': Icon,

  'ui:cacResumeCheckInButton': CacResumeCheckInButton,
  'ui:backButton': BackButton,
  'ui:preCheckDetailCard': PreCheckDetailCard,
  'ui:entityAddButton': EntityAddButton,

  // kiosk specific components
  'ui:kioskCheckinSummaryCard': CheckinSummaryCard,
  'ui:kioskAppointmentSearch': AppointmentSearch,
  'ui:kioskCompanyLogo': KioskCompanyLogo,
  'ui:kioskInputField': KioskInputField,
  'ui:kioskAppointmentCard': AppointmentCard,
}
